@use "foundation/responsive";
@use "foundation/colors";

.service-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & > div {
    margin-bottom: 20px;
    width: 35%;

    @media (max-width: 925px) {
      width: 90%;
    }
  }

  .service-grid, .service-grid-title {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    margin: 0 auto;
    width: 1200px; /* we want this value hard coded because it will change to 100% when reduce size */

    /* 1252px is max size (1200) + margin from container */
    @media (max-width: 1252px) {
      width: 100%;
    }
  }

  .service-grid {
    margin-bottom: 2.2rem;

    @include responsive.phone {
      margin-bottom: 1rem;
    }
  }

  .service-grid-title {
    padding: 1rem 0.4rem;
    font-size: 1rem;
    line-height: 1.4rem;
  }

  .service-tile {
    display: flex;
    flex: 0 0 20%;
    justify-content: center;
    align-items: stretch;

    &:hover {
      cursor: pointer;
    }

    &:before {
      content: '';
      display: table;
      padding-top: 100%;
    }

    @include responsive.phone {
      flex: 0 0 25%;
    }

    @include responsive.small-phone {
      flex: 0 0 33.333%;
    }

    a, span {
      display: flex;
      flex-grow: 1;
      justify-content: space-around;
      align-items: center;

      padding: .375em;

      img {
        display: block;
        margin: 0 auto;
        max-width: 50%;
        max-height: 50%;
      }

      span {
        display: block;
        text-align: center;
        margin-top: 1em;
        color: #fff;
        font-weight: 700;
        line-height: 1.1;
        overflow-wrap: anywhere;

        @include responsive.phone {
          margin-top: .75em;
        }

        @media (max-width: 375px) {
          font-size: .825em;
        }
      }
    }
  }

  .disabled-service-tile {
    opacity: 0.4;

    * {
      cursor: not-allowed;
    }
  }
}
